// import React, { useEffect } from "react";
// import { MainTestView } from "../../../../components/Test";
// import TestStartPage from "./TestStartPage";
// import useTest from "../../../../hooks/useTest";
// import { useDispatch } from "react-redux";
// import { fetchTestQuestionByQuestionId } from "../../../../redux/test/testActions";
// import { DEACTIVATE_TEST } from "../../../../redux/test/types";
// import { Navigate } from "react-router-dom";


// const TestHome = () => {
//   const dispatch = useDispatch()
//   const { questions, isTestActive } = useTest()


//   // (function () {
//   // questions.map(quest => {
//   //   dispatch(fetchTestQuestionByQuestionId(quest.questionNumber))
//   // })
//   // })()
  
//   // New Implementaton
//   const [questionLoadingStatus, setQuestionLoadingStatus] = useState({});
  
//   useEffect(() => {
//     dispatch({type: DEACTIVATE_TEST});
//     const loadQuestions = async () => {
//       // Track loading status for each question
//       const initialLoadingStatus = questions.reduce((acc, question) => {
//         acc[question.id] = 'loading';
//         return acc;
//       }, {});
//       setQuestionLoadingStatus(initialLoadingStatus);
  
//       try {
//         // Parallel loading of questions
//         const questionPromises = questions.map(async (question) => {
//           if (!question.question) {
//             try {
//               await dispatch(fetchTestQuestionByQuestionId(question.id));
//               setQuestionLoadingStatus(prev => ({
//                 ...prev,
//                 [question.id]: 'loaded'
//               }));
//             } catch (error) {
//               setQuestionLoadingStatus(prev => ({
//                 ...prev,
//                 [question.id]: 'error'
//               }));
//             }
//           } else {
//             setQuestionLoadingStatus(prev => ({
//               ...prev,
//               [question.id]: 'loaded'
//             }));
//           }
//         });
  
//         await Promise.all(questionPromises);
//       } catch (error) {
//         console.error('Failed to load questions', error);
//       }
//     };
  
//     loadQuestions();
//   }, []);
  
//   const handleQuestionNavigation = (questionId) => {
//     // If question not loaded, trigger loading
//     if (questionLoadingStatus[questionId] === 'loading') {
//       dispatch(fetchTestQuestionByQuestionId(questionId));
//     }
    
//     // Navigate to question regardless of loading status
//     dispatch({ 
//       type: "UPDATE_EXAM_COUNTER", 
//       payload: questions.findIndex(q => q.id === questionId) 
//     });
//   };
//   // End of New Implementaton
  
  

//   // useEffect(() => {
//   //   dispatch({ type: DEACTIVATE_TEST })
//   //   const fetchQuestionsWithInterval = async () => {
//   //     for (const question of questions) {
//   //       // const questionData = await fetchQuestionById(id);
//   //       if (question.question === "" || question.question === undefined) {
//   //         dispatch(fetchTestQuestionByQuestionId(question.id)) 
//   //         // console.log(`Fetched question with ID ${id}:`, questionData);

//   //         // Introduce an interval before the next API request
//   //         const timer = await new Promise((resolve) => setTimeout(resolve, 2000));
//   //       }
//   //     }
//   //   };

//   //   fetchQuestionsWithInterval();

//   //   return () => {
//   //     // clearTimeout(timer)
//   //   }
//   // }, []);

//   return (
//     <>
//       {/* isTestActive ? <MainTestView /> : <TestStartPage /> */}
//       {
//         isTestActive ? <Navigate to={"/test/start"} /> : <TestStartPage />
//       }
//     </>
//   );
// };

// export default TestHome;


import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import TestStartPage from "./TestStartPage";
import useTest from "../../../../hooks/useTest";
import { fetchTestQuestionByQuestionId } from "../../../../redux/test/testActions";
import { DEACTIVATE_TEST } from "../../../../redux/test/types";

// New type for question loading status
// type QuestionLoadingStatus = {
//   [questionId: string]: 'idle' | 'loading' | 'loaded' | 'error'
// };

const TestHome = () => {
  const dispatch = useDispatch();
  const { questions, isTestActive } = useTest();
  
  // State to track loading status of questions
  const [questionLoadingStatus, setQuestionLoadingStatus] = useState({});
  const [isInitialLoadComplete, setIsInitialLoadComplete] = useState(false);

  useEffect(() => {
    // Deactivate test when component mounts
    dispatch({ type: DEACTIVATE_TEST });

    // Initialize loading status for all questions
    const initialLoadingStatus = questions.reduce((acc, question) => {
      acc[question.id] = question.question ? 'loaded' : 'idle';
      return acc;
    }, {});
    setQuestionLoadingStatus(initialLoadingStatus);

    const loadQuestions = async () => {
      try {
        // Create an array of promises for loading questions
        const loadPromises = questions.map(async (question) => {
          // Only load questions that are not already loaded
          if (!question.question) {
            try {
              setQuestionLoadingStatus(prev => ({
                ...prev,
                [question.id]: 'loading'
              }));

              // Dispatch action to fetch question
              await dispatch(fetchTestQuestionByQuestionId(question.id));

              setQuestionLoadingStatus(prev => ({
                ...prev,
                [question.id]: 'loaded'
              }));
            } catch (error) {
              setQuestionLoadingStatus(prev => ({
                ...prev,
                [question.id]: 'error'
              }));
            }
          }
        });

        // Wait for all questions to be processed
        await Promise.all(loadPromises);
        setIsInitialLoadComplete(true);
      } catch (error) {
        console.error('Failed to load questions', error);
        setIsInitialLoadComplete(true);
      }
    };

    loadQuestions();

    // Cleanup function
    return () => {
      // Any cleanup logic if needed
    };
  }, [dispatch, questions]);

  // Determine if all questions have been attempted to be loaded
  const allQuestionsAttemptedLoading = 
    Object.values(questionLoadingStatus).every(
      status => status === 'loaded' || status === 'error'
    );

  return (
    <>
      {/* 
        Conditional rendering based on test activation and 
        initial question loading completion 
      */}
      {isTestActive && allQuestionsAttemptedLoading ? (
        <Navigate to="/test/start" state={{ startFullScreen: true }}  />
      ) : (
        <TestStartPage 
          questionLoadingStatus={questionLoadingStatus}
          isInitialLoadComplete={isInitialLoadComplete}
        />
      )}
    </>
  );
};

export default TestHome;